export * from '@macs-frontend/features/ui/base';
export { UISharedModule } from '@macs-frontend/features/ui/ui.module';
